<script lang="ts" setup>
import BarTop from '@/components/client/BarTop.vue';
import { useRoute } from 'vue-router';

const route = useRoute();
</script>

<template>
  <div class="subscriber-view">
    <Transition name="header" appear>
      <BarTop />
    </Transition>
    <div class="subscriber-view__view">
      <RouterView v-slot="{ Component }">
        <Transition name="page" appear>
          <div class="subscriber-view__page" :key="route.path">
            <component :is="Component" />
          </div>
        </Transition>
      </RouterView>
    </div>
    
  </div>
</template>

<style scoped>

.subscriber-view {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 100vh;
}

.subscriber-view__view {
  flex-grow: 1;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.subscriber-view__page {
  top: 0;
  left: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
  overflow: auto;
  will-change: opacity, transform;
  scrollbar-width: none;
}

.header-enter-active,
.header-leave-active {
  transition:
    opacity 0.5s ease,
    transform 0.5s ease;
}

.header-enter-from,
.header-leave-to {
  transform: translateY(-100%);
  opacity: 0.01;
}

.page-enter-active {
  transition:
    opacity 0.4s ease,
    transform 0.4s ease;
}

.page-enter-from {
  transform: scale(0.95);
  opacity: 0.01;
}

</style>